module.exports = __webpack_public_path__ + "img/06.c2b9fd5b.png";